<template>
    <ContainerView class="flex w-full h-full" gradient>
      <Loading v-show="loading" :loading="loading"/>
      <Modal v-show="show_message_modal" 
      v-bind:display="show_message_modal"
      :error="error"
      :success="success"
      :note="warning" 
      @positiveClick="closed"
      :positiveButton="'OK'"
      :z_value="'z-50'"
      :default_width="'max-w-xl'"
      id='vote_modal'>
        <div class="w-full px-5 pt-2 pb-4 flex flex-col text-xl justify-center text-center items-center">
          {{ this.modal_message }}
        </div>
      </Modal>
     <CardView rounded max_width="max-w-xl p-4 lg:p-10 m-auto" v-show="show">
          <div class="w-full">
                <div class="text-base flex flex-col mb-4">
                  <img src="https://resource.pafcpic.net/assets/logo/papsi_wordmark.png" class="w-1/4 mb-2" />
                  <h2 class="text-2xl lg:text-3xl font-bold text-theme-primary mb-2 text-left">Update Password</h2>
                  <p class="text-left">Your new password should consist of uppercase and lowercase letters with numbers.</p>
                </div>
                <Textbox type="Password" 
                  id="new_password" 
                  @changed="changed"
                  class="mb-4"
                  v-bind:placeholder="lang('new.password')" 
                  v-bind:value="new_password"
                  :max_length="23"
                  strength
                  peekable
                  required />
                <Textbox type="Password" 
                  id="con_password"
                  @changed="changed"
                  peekable
                  class="mb-4" 
                  v-bind:placeholder="lang('confirm.password')" 
                  v-bind:value="con_password"
                  :max_length="23"
                  required />
                <div class="flex flex-row space-x-3 justify-center pt-4">
                  <Button @clicked="this.$router.push('/forgot-password');" is_secondary :button_text="lang('BACK')"/>
                  <Button @clicked="submit" :theme="'text-white'" :button_text="lang('UPDATE')" :disabled="disabled" rounded/>
                </div>


        </div>
      </CardView>
    </ContainerView>
</template>

<script>
import { defineComponent } from "vue";
import mixin from "@/mixin";
import User from "@/services/User";
import Button from "@/components/controls/ButtonControl.vue";
import Modal from "@/components/controls/ModalControl.vue";
import Textbox from "@/components/controls/TextBoxField.vue";
import Loading from "@/components/controls/LoadingControl.vue";
import ContainerView from "@/components/sections/ContainerView.vue";
import CardView from "@/components/controls/CardView.vue";
export default defineComponent({
  components: {
    CardView,
    Button,
    Modal,
    Textbox,
    Loading,
    ContainerView,
  },
  mixins: [
    mixin,
  ],
  inject: ['setLoading'],
  data() {
    return {
      disabled: true,
      score: 0,
      show_message_modal:false,
      modal_message:'',
      new_password: '',
      con_password: '',
      fade: false,
      show:false,
      loading:false,
      success: false,
      error: false,
      warning: false,
      uuid: '',
    }
  },
  mounted() {
    this.$emit('back', '/forgot-password');

      const store = this.$store;
      const state = store.state.forgot_password_payload;

    this.show = true;
    if(!state.uuid)
    {
      this.$router.push('/');
    }
    else
    {
      this.uuid = state.uuid;
    }
  },
  methods: {
    closed() {
      if(this.success) {
        this.success=false;
        this.show_message_modal = false;
        this.$router.push('/');
      }
      this.show_message_modal = false;
    },
    changed(e) {
      this[e.key] = e.value;
      this.enableButton();
    },
    enableButton() {
      const hasUppercase = /[A-Z]/.test(this.con_password);
      const hasLowercase = /[a-z]/.test(this.con_password);
      const hasNumber = /[0-9]/.test(this.con_password);
      const passwordsMatch = this.new_password === this.con_password;

      if (
        this.new_password !== '' &&
        this.con_password !== '' &&
        hasUppercase &&
        hasLowercase &&
        hasNumber &&
        passwordsMatch
      ) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    submit() {
      const that = this;
      const store = that.$store;
      const state = store.state.forgot_password_payload;
      that.setLoading(true);

      let payload = {
          password:this.new_password,
          con_password:this.con_password,
          hash:state.hash,
          pin:state.pin,
          otp_token:store.state.recovery.otp_token,
          otp_pin:store.state.recovery.otp_pin,
      }
      // console.log(payload);
      User.updatePassword(payload,state.uuid)
        .then(function() {
          that.setLoading(false);
          that.success= true;
          that.error = false;
          that.modal_message = 'Congratulations! You have successfully updated your password.';
          that.show_message_modal= true;
        })
        .catch(function(error) {
          that.error = true;
          that.setLoading(false);
          that.success=false;
          that.show_message_modal= true;
          that.modal_message = error.response.data.message;
        });
    }
  },
  watch:{
    show() {
          setTimeout(() => {
            this.fade=true;
        }, 100);
    },
   }
});
</script>
